import { Network } from '@puzzlehq/sdk';
import { ErrorMessage } from '@src/components/ErrorMessage';
import { LoadingMessage } from '@src/components/LoadingMessage';
import { trpc } from '@src/data/trpc';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/$service')({
  loader: async ({ params }) => {
    const response = await trpc.getStoreService.query({
      network: import.meta.env.VITE_NETWORK! as Network,
      serviceSlug: params.service,
    });
    if (response === null || !response)
      throw new Error(`No service found for "${params.service}"`);
    return response;
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        name: 'description',
        content: loaderData ? loaderData.description : undefined,
      },
      {
        title: loaderData ? `${loaderData.title} Gift Cards` : undefined,
      },
    ],
  }),
  staleTime: 15_000,
  pendingComponent: function Component() {
    const { service } = Route.useParams();

    return <LoadingMessage message={`Loading ${service}`} />;
  },
  errorComponent: function Component({ error }) {
    return <ErrorMessage error={error} />;
  },
  component: function Component() {
    return <Outlet />;
  },
});
